export type { SimpleFormCardProps } from './SimpleFormCard.types'
export { default as SimpleFormCard } from './SimpleFormCard'